import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { XIcon } from 'lucide-react';
import { Cursor } from '../components/common';
import { getApiDirectUrl } from '../config';

export function AuthVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const token = searchParams.get('token');
  const errorParam = searchParams.get('error');

  useEffect(() => {
    // Handle error from redirect
    if (errorParam) {
      const errorMessages: Record<string, string> = {
        invalid_token: 'This link is invalid. Please request a new one.',
        token_used: 'This link has already been used. Please request a new one.',
        token_expired: 'This link has expired. Please request a new one.',
      };
      setError(errorMessages[errorParam] || 'An error occurred. Please try again.');
      return;
    }

    // Redirect to API verify endpoint
    if (token) {
      window.location.href = `${getApiDirectUrl()}/api/auth/magic-link/verify?token=${encodeURIComponent(token)}`;
    } else {
      setError('No verification token provided.');
    }
  }, [token, errorParam, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-base-100 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="card bg-base-100 p-6">
            <div className="w-12 h-12 mx-auto mb-4 bg-error/20 rounded-full flex items-center justify-center">
              <XIcon className="size-6 text-error" />
            </div>
            <h1 className="text-base-content mb-2">Verification Failed</h1>
            <p className="text-base-content/80 mb-6">{error}</p>
            <Link
              to="/login"
              className="btn btn-primary w-full"
            >
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="card bg-base-100 p-6">
          <Cursor size="lg" className="mx-auto mb-4" />
          <h1 className="text-base-content mb-2">Verifying</h1>
          <p className="text-base-content/80">Please wait while we sign you in...</p>
        </div>
      </div>
    </div>
  );
}
